import { IMenuItem } from "@common/models/CMS";
import CaptchaPopup from "@components/CaptchaPopup";
import ErrorBoundary from "@components/ErrorBoundary";
import Loading from "@components/general/Loading";
import { Root } from "@components/Root";
import { getRoutes, IRouteItem } from "@config/route";
import { Culture } from "@core/index";
import { store } from "@misc/Reducer";
import { NotFound } from "@pages/NotFound";
import { Page } from "@pages/page";
import React, { FC, Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
const Ltr = React.lazy(() => import("@components/Ltr"));
const Rtl = React.lazy(() => import("@components/Rtl"));

interface IAppProps {
  menu: IMenuItem[];
}

const App: FC<IAppProps> = ({ menu }) => {
  let routeItems: IRouteItem[] = [];

  const renderRoutes = (items: IRouteItem[], prefix: string): JSX.Element[] => {
    let links: JSX.Element[] = [];
    for (let i = 0, il = items.length; i < il; ++i) {
      const item = items[i];
      const basePath = prefix ? `${prefix}/` : "";
      links.push(<Route key={i} path={`${basePath}${item.link}`} exact={item.exact} component={item.component} />);
      if (item.children)
        links = links.concat(renderRoutes(item.children, item.link));
    }
    return links;
  }

  const getDynamicRoutes = (data: IMenuItem[]) => {
    data?.forEach((menuItem: IMenuItem) => {
      renderMenu(menuItem);
    });
  }

  const renderMenu = (item: IMenuItem) => {
    item.menuItemsList?.menuItems.forEach((menuItem) => {
      if (menuItem?.menuItemsList?.menuItems?.length)
        renderMenu(menuItem);
      if (menuItem?.linkMenuItem?.url) {
        const routeItem = routeItems.find(ri => ri.link.toLowerCase() === menuItem.linkMenuItem?.url.toLowerCase());
        if (!routeItem)
          routeItems.unshift({ link: menuItem.linkMenuItem.url, title: menuItem.displayText || "", component: Page });
      }
    });
  }

  routeItems = getRoutes(false);
  getDynamicRoutes(menu);


  const provider = (
    <Provider store={store}>
      <BrowserRouter basename={`/${Culture.getLocale().lang}`}>
        <ScrollToTop />
        <Root menuItems={menu}>
          <ErrorBoundary>
            <Switch>
              {renderRoutes(routeItems, "")}
              <Route component={NotFound} />
            </Switch>
          </ErrorBoundary>
        </Root>
        <CaptchaPopup />
      </BrowserRouter>
    </Provider>
  );

  return (
    <div className="app">
      <Suspense fallback={<Loading showLoader={true} absolute={false} />}>
        {Culture.getLocale().dir === "rtl" ? <Rtl>{provider}</Rtl> : <Ltr>{provider}</Ltr>}
      </Suspense>
    </div >
  );
}

export default App;
